import { render, staticRenderFns } from "./ModRecords.vue?vue&type=template&id=4000bcd2&"
import script from "./ModRecords.vue?vue&type=script&lang=js&"
export * from "./ModRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports